import { render } from "./SignupForm.vue?vue&type=template&id=62540736&scoped=true"
import script from "./SignupForm.vue?vue&type=script&lang=js"
export * from "./SignupForm.vue?vue&type=script&lang=js"

import "./SignupForm.vue?vue&type=style&index=0&id=62540736&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62540736"]])

export default __exports__